import { Outlet, useLocation } from "react-router";
import "./PlanManager.scss";

/**
 * Plan Manager page shell — page header and the active sub-route outlet.
 * The body is delegated to nested route components (e.g. Plans, Networks).
 * @returns {import('react').JSX.Element}
 */
const PlanManager = () => {
    const { pathname } = useLocation();

    return (
        <div className="container plan-manager-page">
            <div className="plan-manager-page__intro">
                <p className="title">Plan Manager</p>
                <p className="sub-title">
                    {pathname.startsWith("/plan-manager/pre-enrollment-custom")
                        ? "Pre-enrollment custom"
                        : pathname.startsWith("/plan-manager/networks")
                            ? "Networks"
                            : "Plans"}
                </p>
            </div>

            <Outlet />
        </div>
    );
};

export default PlanManager;
